import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

/** Filas de espera mientras carga una tabla: ocupan el mismo espacio que tendrán los datos. */
export function TableSkeleton({ cols, rows = 6 }: { cols: number; rows?: number }) {
  return (
    <>
      {Array.from({ length: rows }, (_, r) => (
        <tr key={r} className="skeleton-row" aria-hidden="true">
          {Array.from({ length: cols }, (_, c) => (
            <td key={c}>
              <span className="skeleton" style={{ width: `${c === 1 ? 70 : 35 + ((r * 7 + c * 13) % 40)}%` }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

/** Estado vacío con ícono, una frase clara, una pista y (si aplica) la acción siguiente. */
export function EmptyState({ icon = 'inbox', title, hint, action }: { icon?: IconName; title: ReactNode; hint?: ReactNode; action?: ReactNode }) {
  return (
    <div className="empty emptystate">
      <span className="emptyicon">
        <Icon name={icon} size={22} />
      </span>
      <b>{title}</b>
      {hint ? <small>{hint}</small> : null}
      {action ? <div className="emptyaction">{action}</div> : null}
    </div>
  );
}
